import React from 'react'
import './Style/card.css'
import { useRef } from 'react';

const Card = ({background,children,fit='cover'}) => {
  const textRef = useRef(null);
  
  // Function to reset scroll position when hover ends
  const handleMouseLeave = () => {
    if (textRef.current) {
      textRef.current.scrollTop = 0;
    }
  };
  return (

    
    <div className='card' style={{backgroundImage:`url(${background})`,backgroundSize:fit}}
    onMouseLeave={handleMouseLeave} tabIndex={0}>
            <div className='cardText'   ref={textRef}>
              {children}
            </div>
          </div>
  )
}

export default Card